import {
  ComponentsOverrides,
  ComponentsProps,
  ComponentsVariants,
} from '@mui/material'
import { COLORS } from '~theme/colors'

declare module '@mui/material/TableRow' {
  interface TableRowPropsVariantOverrides {
    withHover: true
  }

  interface TableRowOwnProps {
    variant?: 'withHover'
  }
}

export interface MuiTableRowData {
  defaultProps?: ComponentsProps['MuiTableRow']
  styleOverrides?: ComponentsOverrides['MuiTableRow']
  variants?: ComponentsVariants['MuiTableRow']
}

export const MuiTableRow: MuiTableRowData = {
  styleOverrides: {
    root: {
      backgroundColor: COLORS.greys.ultraLight,
      verticalAlign: 'top',
      boxShadow: `0px 0px 0px 8px ${COLORS.primary.white}`,
      '.MuiTableCell-root': {
        color: COLORS.secondary.darkBlue,
      },
      variants: [],
    },
    head: {
      backgroundColor: 'transparent',
      boxShadow: 'none',
      '&:hover': {
        backgroundColor: 'transparent',
        boxShadow: 'none',
        cursor: 'default',
      },
    },
  },
  variants: [
    {
      props: { variant: 'withHover' },
      style: {
        transition: 'background-color 0.2s ease-in-out',
        '&:hover': {
          backgroundColor: COLORS.primary.white,
          cursor: 'pointer',
          outline: `3px solid ${COLORS.greys.greyTint}`,
          td: {
            '&:first-of-type': {
              borderLeft: `2px solid ${COLORS.greys.greyTint}`,
            },
            '&:last-of-type': {
              borderRight: `2px solid ${COLORS.greys.greyTint}`,
            },
          },
        },
      },
    },
  ],
}
